import React, { useCallback } from "react";
import { auth } from "firebase/app";
import { Formik } from "formik";
import { toastr } from "react-redux-toastr";

import { SignLayout } from "../../components/layouts/SignLayout";

import { FormComponent } from "./FormComponent";
import {
  FormActionTypes,
  initialValues,
  validationSchema,
  ValueTypes,
} from "./formSettings";

export const SignUpForm: React.FC = () => {
  const handleOnSubmit = useCallback((values: ValueTypes, actions: FormActionTypes) => {
    const { email, password } = values;

    auth().createUserWithEmailAndPassword(email, password)
      .catch(({ message }) => {
        toastr.error("Sign In with email", message);
      })
      .finally(() => {
        actions.setSubmitting(false);
      });
  }, []);

  return (
    <SignLayout type="up">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleOnSubmit}
        component={FormComponent}
        enableReinitialize
      />
    </SignLayout>
  );
};
